/*
 * LMC BF-Reveal — scroll-triggered reveal for the bodyfriend-style landing.
 * EXPERIMENT (experiment/bodyfriend-landing).
 *
 * Elements marked [data-bf-reveal] fade/slide up as they enter the viewport.
 * Graceful by design:
 *  - prefers-reduced-motion: reduce  -> opacity-only fade, no movement
 *    (handled in CSS; movement is what reduced-motion suppresses, a soft
 *    fade is acceptable).
 *  - no IntersectionObserver / JS off -> content stays visible (the hiding
 *    rule only applies once we add `.bf-reveal-ready` to <html>).
 */
(function () {
  if (window.__bfReveal) return;
  window.__bfReveal = true;

  function init() {
    var els = document.querySelectorAll('[data-bf-reveal]');
    if (!els.length) return;

    document.documentElement.classList.add('bf-reveal-ready');

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) els[i].classList.add('bf-in');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('bf-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
